import { useState } from "react";
import { SYNC_PENDING_TEXT } from "../api/client";
import type { ActionResult } from "../overlay/useWalletAction";
import { usePlayer } from "../state/PlayerContext";

export function ActionStatus({ busy, waiting, error, result }: { busy: boolean; waiting: boolean; error: string | null; result: ActionResult | null }) {
  if (waiting) return <p className="status waiting">{SYNC_PENDING_TEXT}</p>;
  if (busy) return <p className="status">Waiting for your wallet…</p>;
  if (error) return <p className="status error">{error}</p>;
  if (result)
    return (
      <p className="status ok">
        Sent.{" "}
        <a href={result.explorer} target="_blank" rel="noreferrer">
          View transaction
        </a>
      </p>
    );
  return null;
}

export type PayFeeIn = "RCD" | "SOL";

/** The fee currency for wallet actions: ₽ by default, SOL whenever the Kora relay is unavailable. */
export function usePayFeeIn(): { value: PayFeeIn; onChange: (v: PayFeeIn) => void; relayAvailable: boolean } {
  const { me } = usePlayer();
  const relayAvailable = me?.fees.relayAvailable ?? false;
  const [choice, setChoice] = useState<PayFeeIn>("RCD");
  return { value: relayAvailable ? choice : "SOL", onChange: setChoice, relayAvailable };
}

export function PayFeeSelect({ value, onChange, relayAvailable }: { value: PayFeeIn; onChange: (v: PayFeeIn) => void; relayAvailable: boolean }) {
  return (
    <label className="inline">
      Pay network fee in{" "}
      <select value={value} onChange={(e) => onChange(e.target.value as PayFeeIn)}>
        <option value="RCD" disabled={!relayAvailable}>
          ₽ (RCD){relayAvailable ? "" : " (unavailable)"}
        </option>
        <option value="SOL">SOL</option>
      </select>
    </label>
  );
}
